import type { Product } from '../types/api';

const WEIGHABLE_KEYWORDS = [
  'hortifruti',
  'verdura',
  'verduras',
  'legume',
  'legumes',
  'fruta',
  'frutas',
  'tomate',
  'tomates',
  'cebola',
  'cebolas',
  'alface',
  'couve',
  'cenoura',
  'batata',
  'pepino',
  'pimentao',
  'abobrinha',
  'berinjela',
  'banana',
  'laranja',
  'maca',
  'melancia',
  'mamao',
  'abacaxi',
  'morango',
  'quiabo',
  'repolho',
  'rucula',
  'agriao',
  'cheiro verde',
  'salada',
  'a granel',
];

function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

export function isWeighableText(...parts: Array<string | null | undefined>): boolean {
  const text = normalizeText(parts.filter(Boolean).join(' '));
  return WEIGHABLE_KEYWORDS.some(keyword => text.includes(normalizeText(keyword)));
}

export function isWeighableProduct(product: Pick<Product, 'name' | 'description' | 'category'>): boolean {
  return isWeighableText(product.name, product.description, product.category);
}

export function getWeighableWarning(): string {
  return 'Produto pesavel: o valor final pode variar conforme a pesagem.';
}
